import angularModule from 'Cohorts/angularModule/scripts/cohorts_module';

angularModule.factory('IsPeriodItem', [
    '$injector',
    $injector => {
        const AModuleAbove = $injector.get('AModuleAbove');
        const dateHelper = $injector.get('dateHelper');

        return new AModuleAbove({
            _getCachedRelativeDateFromPeriodEnd(name, offsetProp, unit = 'days') {
                const cacheKey = `$$cached${name}`;

                // if nothing has changed, return the last date we calculated
                if (
                    this[cacheKey] &&
                    this[cacheKey].endDate === this.period().endDate &&
                    this[cacheKey][offsetProp] === this[offsetProp]
                ) {
                    return this[cacheKey].date;
                }

                const date = dateHelper.addInDefaultTimeZone(this.period().endDate, this[offsetProp], unit);

                this[cacheKey] = {
                    endDate: this.period().endDate,
                    date,
                };
                this[cacheKey][offsetProp] = this[offsetProp];

                return date;
            },
        });
    },
]);
